import { render, staticRenderFns } from "./SidebarJfx.vue?vue&type=template&id=2c9a8205&scoped=true&"
import script from "./SidebarJfx.vue?vue&type=script&lang=js&"
export * from "./SidebarJfx.vue?vue&type=script&lang=js&"
import style0 from "./SidebarJfx.vue?vue&type=style&index=0&id=2c9a8205&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9a8205",
  null
  
)

export default component.exports